module.exports = __webpack_public_path__ + "f55144edc75d0268c3e48bf384f78ce9.pdf";